// extracted by mini-css-extract-plugin
module.exports = {"modalHeader":"styles_modalHeader__1Ffd_","modalBody":"styles_modalBody__1u8XK","title":"styles_title__1nQ8F"};